import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=25b249b6&scoped=true&"
import script from "./DownloadCenter.vue?vue&type=script&lang=js&"
export * from "./DownloadCenter.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCenter.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DownloadCenter.vue?vue&type=style&index=1&id=25b249b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b249b6",
  null
  
)

export default component.exports